import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme:Theme) => {
	return {
		button: {
			textTransform: "none"
		},
		dialogContent: {
			[theme.breakpoints.down("xs")]: {
				display: "flex",
				alignItems: "flex-end",
				textAlign: "center",
			},
		},
		dialogActions: {
			[theme.breakpoints.down("xs")]: {
				height: "50%",
				justifyContent: "center",
				alignItems: "flex-start",
				paddingLeft: 30,
				paddingRight: 30,
				"& button": {
					flex: 1,
				}
			},
		},
	} satisfies Record<string, CSSObject>;
};
